import { render, staticRenderFns } from "./Principal.vue?vue&type=template&id=50dd5d20&scoped=true&v-if=isPrincipal&"
import script from "./Principal.vue?vue&type=script&lang=js&"
export * from "./Principal.vue?vue&type=script&lang=js&"
import style0 from "./Principal.vue?vue&type=style&index=0&id=50dd5d20&scoped=true&lang=css&"
import style1 from "./Principal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dd5d20",
  null
  
)

export default component.exports